import { useGenericModal } from "@/shared/common/GenericModal";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import PartyIcon from "public/images/icon_party.svg";
import { EventType } from "@/global/store/data/types";
import { BasicEventCard } from "@/shared/common/EventCard/BasicEventCard";
import { pluralize } from "@/global/utils/utils";

export function useCongratsModal() {
  const theme = useTheme();
  const genericModal = useGenericModal();

  const fire = (args: {
    events: EventType[];
    title?: string;
    description?: string;
  }) => {
    genericModal.set({
      isOpen: true,
      title: "",
      renderHeader: () => <></>,
      isCloseButtonHidden: true,
      confirmButtonText: "Close",

      description: (
        <Box>
          <Box pt={8} />
          <Stack alignItems={"center"} spacing={4}>
            <Box
              aria-label="Party Icon"
              sx={{
                width: 64,
                height: 64,
                backgroundColor: theme.palette.primary.main,
                WebkitMaskImage: `url(${PartyIcon.src})`,
                maskImage: `url(${PartyIcon.src})`,
                WebkitMaskRepeat: "no-repeat",
                maskRepeat: "no-repeat",
                WebkitMaskPosition: "center",
                maskPosition: "center",
                WebkitMaskSize: "contain",
                maskSize: "contain",
              }}
            />
            <Stack alignItems={"center"} spacing={1}>
              <Typography variant="h6" fontWeight={700} lineHeight={1.2}>
                {args.title || "Congrats!"}
              </Typography>
              <Typography variant="body1" textAlign={"center"}>
                {args.description ||
                  (args.events.length > 1
                    ? `You've unlocked ${args.events.length} special ${pluralize("event", args?.events?.length)}!` // prettier-ignore
                    : "You've unlocked a special event!")}
              </Typography>
            </Stack>
            <Stack width={"100%"} spacing={2}>
              {args.events.map((event) => (
                <BasicEventCard key={event.eventCode} event={event} />
              ))}
            </Stack>
          </Stack>
        </Box>
      ),
    });
  };

  return { fire };
}
